import styled, { keyframes } from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/Loading/LoadingScreen.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// LOADING SCREEN
// Unlike every *Step.styles.js, this isn't scoped inside
// AssessmentStepShell's <Section> — the Loading Screen is a full-screen
// transitional state with no step counter/Previous/Next footer, so it
// declares its own --c-*/--sp-* fallback-free layout instead of relying
// on the shell's scoped custom properties.
// ═══════════════════════════════════════════════════════════════════════════════

export const Screen = styled.div`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--sp-6, 32px) var(--sp-4, 16px);
`;
Screen.displayName = "Screen";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 4px solid ${DIET_C.secondary}33;
  border-top-color: ${DIET_C.primary};
  animation: ${spin} 0.9s linear infinite;
  margin-bottom: var(--sp-5, 24px);
`;
Spinner.displayName = "Spinner";

export const Message = styled.p`
  color: var(--c-text, #1a1a1a);
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0 0 var(--sp-2, 8px);
  min-height: 1.4em;
  transition: opacity var(--t-fast, 0.2s) ease;
`;
Message.displayName = "Message";

export const ProgressTrack = styled.div`
  width: min(360px, 80vw);
  height: 8px;
  border-radius: 999px;
  background: ${DIET_C.secondary}33;
  overflow: hidden;
  margin: var(--sp-4, 16px) 0;
`;
ProgressTrack.displayName = "ProgressTrack";

export const ProgressFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: ${DIET_C.primary};
  width: ${({ $percent }) => Math.max(0, Math.min(100, $percent))}%;
  transition: width 0.25s ease-out;
`;
ProgressFill.displayName = "ProgressFill";

export const ProgressPercent = styled.span`
  color: var(--c-text-muted, #666);
  font-size: 0.8rem;
  font-weight: 600;
`;
ProgressPercent.displayName = "ProgressPercent";

export const ReassuranceText = styled.p`
  color: var(--c-text-muted, #666);
  font-size: 0.88rem;
  margin: var(--sp-4, 16px) 0 0;
`;
ReassuranceText.displayName = "ReassuranceText";

export const ErrorPanel = styled.div`
  margin-top: var(--sp-5, 24px);
  padding: var(--sp-4, 16px);
  border-radius: var(--r-sm, 10px);
  background: ${DIET_C.accent}12;
  border: 1px solid ${DIET_C.accent}44;
  max-width: 420px;
`;
ErrorPanel.displayName = "ErrorPanel";

export const ErrorText = styled.p`
  color: ${DIET_C.accent};
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 var(--sp-3, 12px);
`;
ErrorText.displayName = "ErrorText";

export const RetryButton = styled.button`
  padding: 10px 24px;
  border-radius: 999px;
  background: ${DIET_C.primary};
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: opacity var(--t-fast, 0.2s);

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 3px solid var(--c-accent, ${DIET_C.accent});
    outline-offset: 2px;
  }
`;
RetryButton.displayName = "RetryButton";
